import React, { useEffect, useState } from "react";
import axios from "axios";
import { IMAGE_URL, URL_API } from "../../variable";
import {
  ClimbingBoxLoader,
  BounceLoader,
  BarLoader,
  BeatLoader,
} from "react-spinners";
import { css } from "@emotion/react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";


function FormInfoList() {
  const loaderCss = css`
    margin: auto;
  `;
  const history = useHistory();
  const [formInfo, setFormInfo] = useState([]);
  const [loading, setloading] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getFormInfo();
  }, []);

  const getFormInfo = () => {
    axios.get(URL_API + "auth/admin/form-info").then((response) => {
      if (response.data.status === 200) {
        setLoadMoreAds(response?.data?.selectList);
      }
    });
  };





  const destroySelectOption = (id) => {

    axios
      .post(URL_API + `auth/admin/form-info/delete/${id}`)
      .then((response) => {
        if (response.data.status === 200) {
          history.push("/admin/form-info");
          toast.success("Select Option Deleted Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          getFormInfo();
        }
      });
  };



  const initialPostList = 10 // Number of loadMoreAds to display initially
  const incrementInitialPostList = 10 // Number of loadMoreAds to add each time the "load more" button is clicked
  const [displayPosts, setDisplayPosts] = React.useState(initialPostList)
  const [loadMoreAds, setLoadMoreAds] = React.useState()
  const loadMore = () => {
    setDisplayPosts(displayPosts + incrementInitialPostList)
  }




  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Form Options List</CardTitle>
              </CardHeader>
              <div
                style={{
                  paddingLeft: "80%",
                  paddingBottom: "2%",
                  fontSize: "16px",
                }}
              >
                <Link to={`/admin/form-infos/create`}>
                  <strong>Add Option + </strong>
                </Link>
              </div>
              <CardBody>
                <Table responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>#</th>
                      <th>Select Name</th>
                      <th>Option ID</th>
                      <th>Option Text</th>
                      <th>Created At</th>
                      <th>Action</th>
                      {/* <th className="text-right">Salary</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {
                      loadMoreAds?.slice(0, displayPosts)?.map(
                        (info, index) => {
                          return (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{info?.select_type}</td>
                              <td>{info?.id}</td>
                              <td>{info?.select_option}</td>
                              <td>
                                {moment(info?.created_at).format(
                                  " DD MMMM,YYYY"
                                )}
                              </td>
                              <td>
                                <Link to={`form-infos/edit/${info.id}`}>
                                  <i class="far fa-edit fa-lg"></i>
                                </Link>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <a style={{ color: "red" }} onClick={() => destroySelectOption(info.id)}>
                                  <i class="fas fa-trash-alt fa-lg"></i>
                                </a>
                              </td>
                            </tr>
                          );
                        }
                        // )
                      )
                    }
                  </tbody>
                </Table>
                {displayPosts < loadMoreAds?.length ? (
                  <div className="container" style={{ textAlign: "center", marginTop: '30px', padding: '10px' }}>
                    <div className="row" >
                      <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="btn-default-section">
                          <button className="btn btn-secondary" onClick={loadMore} style={{ padding: '15px' }}>
                            Load More
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default FormInfoList;
